<template>
  <div :class="$style['cooper-page']">
    <div :class="$style['header']">合作机构</div>
    <div :class="$style['page-footer']">
      <div v-for="(item,index) in  list" :key="index" :class="$style['footer']">
        <img src="@/assets/img/number/plume-l.png" />
        <p>{{item.name}}</p>
        <img src="@/assets/img/number/plume-r.png" />
      </div>
    </div>
    <div :class="$style['page-footer-last']">
        <div v-for="(item,index) in  config" :key="index" :class="$style['footer-last']">
          <img src="@/assets/img/number/plume-l.png" />
          <p>{{item.name}}</p>
          <img src="@/assets/img/number/plume-r.png" />
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
    list () {
      return [
        {
          name: '神州信息'
        },
         {
          name: '中电金信'
        },
        {
          name: '培训杂志'
        },
        {
          name: '知链科技'
        },
        {
          name: '甫瀚咨讯'
        },
        {
          name: '远见教育'
        }
      ]
    },
    config () {
      return [
        {
          name: 'GHR'
        },
        {
          name: '施耐德电气'
        },
        {
          name: '电子工业出版社'
        }
      ]
    }
  },
  created () {
  },
  mounted () {
  },
  watch: {
  },
  methods: {}
}
</script>
<style lang='scss' module>
.cooper-page {
  box-sizing: border-box;
  width: 100%;
  padding: 50px 24px 30px;
  background: #F0F4F8;
  text-align: center;
  & .header {
    font-size: 20px;
    font-weight: 500;
    color: #404040;
  }
  & .page-footer {
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 24px;
    & .footer {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 0 6px 20px;
      & img {
        width: 11px;
        height: 20px;
      }
      & p {
        margin: 0 6px;;
        font-size: 14px;
        font-weight: 500;
        color: #4289FF;

      }
    }
  }
  & .page-footer-last {
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    width: 100%;
    & .footer-last {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 0  0 20px;
      & img {
        width: 11px;
        height: 20px;
      }
      & p {
        margin: 0 6px;;
        font-size: 14px;
        font-weight: 500;
        color: #4289FF;

      }
    }
  }

}
</style>
